import { Component, Input, ViewChild,OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SearchStudentByKeywordsRequest } from 'src/app/models/Requests/SearchStudentByKeywordsRequest.model';
import { StudentDetails } from 'src/app/models/Search/studentdetails';
import { ViewStudentDetailsComponent } from '../dialogs/view-student-details/view-student-details.component';
import { StudentService } from 'src/app/services/student.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Login } from 'src/app/models/login.model';
import { MatPaginator, PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-search-by-keyword',
  templateUrl: './search-by-keyword.component.html',
  styleUrls: ['./search-by-keyword.component.scss']
})
export class SearchByKeywordComponent implements OnChanges{

  isSearchBoxopen: boolean = false;
  searchRequest = new SearchStudentByKeywordsRequest("", "", "", "", 0, 0, 0, 0, 0, 0, 0);
  error: string = "";
  isSearch: boolean = false;
  displayedColumns: string[] = ['firstName', 'lastName', 'dateofBirth', 'location','memberid', 'rosterStatus', 'actions']
  students: StudentDetails[] = [];
  loggedInUser = new Login("", "", "", "", "", "", 0, false,false,false, "");
  dataSource: MatTableDataSource<StudentDetails> = new MatTableDataSource(this.students);
  dataSourceWithPageSize = new MatTableDataSource(this.students);
  @Input() selectedSchoolYear: string;
  @Input() isSearchKeyword:boolean= false;

  @ViewChild('searchByKeywordPaginator', { static: false }) searchByKeywordPaginator: MatPaginator;
  pageEvent: PageEvent = {
    pageIndex: 0,
    pageSize: 10,
    length: 100
  };
  manualPage: number;
  pageIndex: number = 0;

  pageNumbers: number[] = [];
  noOfPages: number = 0;
  viewSearch:boolean=false;
  goTo:number;
  selectedPageNumber : number = 1;
  currenttotalPages:number = 0;
  showMsg: boolean = false;

  isLoadingStudents: boolean = false;


  constructor(private matDialog: MatDialog, private studentService: StudentService,
     private authService: AuthenticationService, private cdref: ChangeDetectorRef) {
    this.authService.setLogin.subscribe(loginData => {
      this.loggedInUser = loginData;
    });
  }

  ngOnChanges(changes: SimpleChanges) {


    if((changes['isSearchKeyword']?.currentValue) || (changes['selectedSchoolYear']?.currentValue)){

      this.reset();
      this.viewSearch = false;
    }
  }





  ToggleSearchBox() {

    this.isSearchBoxopen = !this.isSearchBoxopen;
    if(this.isSearchBoxopen){
      this.viewSearch = false;
    }
    else{
      this.viewSearch=true;
    }
  }

  Search() {

    if (this.IfAllFieldsEmpty()) {
      this.error = "Enter atleast one search field!";
      this.isSearch = false;
      this.viewSearch=false
      return;
    }

    this.isLoadingStudents = true;

    this.searchRequest.accessID = this.loggedInUser.accessId;
    this.searchRequest.accessLevel = this.loggedInUser.accessLevel;
    this.searchRequest.schoolYear = parseInt(this.selectedSchoolYear);
    this.searchRequest.userId = this.loggedInUser.userId;
    this.studentService.searchStudentsByKeywords(this.searchRequest).subscribe((result) => {

      this.students = result;
      this.ToggleSearchBox();
      this.dataSource = new MatTableDataSource(this.students);
      if(this.searchByKeywordPaginator ){
      this.dataSource.paginator = this.searchByKeywordPaginator;
      }
      this.cdref.detectChanges();
      this.setPageNumbers();
      this.updateGoto();

      if (this.students.length == 0) {
        this.showMsg = true;
      }else{
        this.showMsg = false;
      }
      this.isLoadingStudents = false;
    });
    this.error = "";
    this.isSearch = true;
  }

  IfAllFieldsEmpty() {
    if (this.searchRequest.firstName == '' && this.searchRequest.lastName == '' && this.searchRequest.dateOfBirth == '' && this.searchRequest.ssn == '') {
      return true;
    }
    return false;
  }

  reset() {
    this.isSearch = false;
    this.error = "";
    this.showMsg = true;
    this.searchRequest = new SearchStudentByKeywordsRequest("", "", "", "", 0, 0, 0, 0, 0, 0, 0);
    this.students = [];
    this.dataSource = new MatTableDataSource(this.students);
  }

  OpenStudentDetailsPopup(element: StudentDetails) {

    if (element != null) {
      this.matDialog.open(ViewStudentDetailsComponent, {
        data: element
      });
    }
  }





  updateGoToPage() {

    this.searchByKeywordPaginator.pageIndex = this.goTo - 1;
  }

  goToChange() {
    this.searchByKeywordPaginator.pageIndex = this.goTo - 1;
    const event: PageEvent = {
      length: this.searchByKeywordPaginator.length,
      pageIndex: this.searchByKeywordPaginator.pageIndex,
      pageSize: this.searchByKeywordPaginator.pageSize
    };
    this.searchByKeywordPaginator.page.next(event);
  }

  updateGoto() {
    this.goTo = (this.pageIndex || 0) + 1;
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.searchByKeywordPaginator?.length/ this.searchByKeywordPaginator?.pageSize); i++) {
      this.pageNumbers.push(i);
    }
  }
  onPaginateChange(event:any){
    this.selectedPageNumber = event.pageIndex +1;
    this.goTo = this.selectedPageNumber;
    this.setPageNumbers();
  }

  setPageNumbers(){
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.searchByKeywordPaginator?.length/ this.searchByKeywordPaginator?.pageSize); i++) {
      this.pageNumbers.push(i);
    }
    this.currenttotalPages = this.pageNumbers.length;
  }

}
